import SubPage from '../../subpages/SubPage';
import AdminPicture from '../../components/AdminPicture';
import AdminMovie from '../../components/AdminMovie';
import { Container, Table } from 'react-bootstrap';
import { Route, Switch } from 'react-router-dom';
import Notice from '../../subpages/Notice';
import QNA from '../../subpages/QNA';
import DashBoardResult from '../../subpages/DashBoardResult';
import AdminNoticeForm from '../../components/AdminNoticeForm';

const BoardManagement = ({ history }) => {
  const title = '게시판 관리';
  const parent_link = 'admin/board'; // 반드시, 상대경로로 시작
  const side_list = [
    ['notice?pageNo=1', '공지사항'],
    ['qna?pageNo=1', 'Q&A'],
  ];
  const bg_info = {
    link: 'https://user-images.githubusercontent.com/46194004/123917479-ce698400-d9bd-11eb-9599-975e219cee76.png',
    text: title,
  };
  return (
    <div>
      <SubPage
        title={title}
        parent_link={parent_link}
        side_list={side_list}
        isOnePage={false}
        background_info={bg_info}
      />
      <Container className="col-10 offset-2 ps-5">
        <Switch>
          <Route
            path={`/${parent_link}/notice`}
            component={Notice}
            exact={true}
          />
          <Route
            path={`/${parent_link}/qna/:articleId`}
            render={() => <DashBoardResult history={history} />}
          />
          <Route path={`/${parent_link}/qna`} component={QNA} />
          <Route
            path={`/${parent_link}/notice/new_post`}
            component={AdminNoticeForm}
          />
          <Route
            path={`/${parent_link}/notice/:articleId`}
            component={DashBoardResult}
          />
        </Switch>
      </Container>
    </div>
  );
};
export default BoardManagement;
